import { loadMrsConnectedAccounts } from '../utils/loadMrsConnectedAccounts';
import { loadDefaultAddressOption } from '../utils/loadDefaultAddressOption';

export async function initConnectedAccountsFull(): Promise<void> {
    await loadMrsConnectedAccounts();
    await loadDefaultAddressOption();
}
